export default __webpack_public_path__ + "static/media/drybarBlackBig.043ba3d7.svg";